
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

enum EumLoadStatus {
  Success = 'success',
  Fail = 'fail',
}

@Observer
@Component({
  components: {
    LazyImg
  }
})
export default class RealLazyImg extends Vue {
  @Prop({ required: true, default: () => [] }) realUrlList: string[]

  @Ref()
  realLazyImg!: HTMLDivElement

  status: EumLoadStatus[] = []
  ob: IntersectionObserver | null = null

  isActive: boolean = false

  @Emit('load-url-fail')
  onLoadError(idx: number) {
    this.status[idx] = EumLoadStatus.Fail
  }

  onLoadImg(idx: number) {
    this.status[idx] = EumLoadStatus.Success
  }

  created(): void {}

  mounted(): void {
    this.ob = new IntersectionObserver(
      entity => {
        if (entity[0].isIntersecting) {
          this.$emit('pre-load')
          this.isActive = true
        } else {
          this.isActive = false
        }
      },
      {
        root: null,
        threshold: [0, 1]
      }
    )

    this.ob.observe(this.realLazyImg)
  }

  updated(): void {}

  destroyed(): void {
    if (this.ob) {
      this.ob.disconnect()
    }
  }
}
